




export function strArrayToString(arr: string[], del?: string, rightTruncDel?: string)
{
    if(arr !== undefined)
    {
        if(arr.length >= 1)
        {
            let outString: string = "";

            if(rightTruncDel === "" || !rightTruncDel)
            {
                for(let i = 0; i < (arr.length - 1); i++)
                {
                    outString += arr[i] + del;
                }

                return(outString + arr[arr.length - 1]);
            }
            else
            {
                for(let i = 0; i < (arr.length - 1); i++)
                {

                    outString += arr[i].split(rightTruncDel)[0] + del;
                }

                return(outString + arr[arr.length - 1].split(rightTruncDel)[0]);
            }
        }
    }
    else
    {
        console.log("[strArrayToString] ERROR: arr is undefined");
    }

    return("x_x");
}
